module.exports = {
    login: 0,
    register: 1,
    forgotPassword: 2
};


/** WEBPACK FOOTER **
 ** ./src/constants/form-type.js
 **/